import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Pet } from '../models/user-profile.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-add-mascota',
  imports: [FormsModule, CommonModule],
  templateUrl: './add-mascota.component.html',
  styleUrl: './add-mascota.component.scss'
})
export class AddMascotaComponent implements OnInit {
 
  private readonly baseUrl = environment.apiBaseUrl;
  private http = inject(HttpClient);
  private snackbar = inject(MatSnackBar);
  private dialog = inject(MatDialog);
  private router = inject(Router);
  numbers: number[] = []; 
  selectedFileBase64: string | null = null;
  imagenPreview: string | null = null;
  
  operation:string = '';
  id :string='';
  update:boolean = false;

  nombre: string = '';
  especie: string = '';
  genero: string = '';
  raza: string = '';
  edad: string = '';
  peso: string = '';
  identificador: string = '';
  url_img:String ='';
  


  pet: Pet[] = [];
  pet_information :any;


  constructor(private route: ActivatedRoute) {
    // age of pet
    for (let i = 1; i <= 20; i++) {
      this.numbers.push(i);
    }
  }
  ngOnInit(): void {
     this.route.queryParams.subscribe(params => {
           console.log(params);
           this.update=params['update'];          
           if (this.update) {
            const pet_storage = localStorage.getItem('profileData');
            this.id=params['id'];
            if(pet_storage){
              const profileData = JSON.parse(pet_storage);
              this.pet = profileData.pets;
              this.pet_information = this.pet.filter(i => i.idPet == params['id'])
              console.log(this.pet_information[0]);  
              this.nombre = this.pet_information[0].petName;
              this.especie = this.pet_information[0].specie;
              this.genero  = this.pet_information[0].gender;
              this.raza = this.pet_information[0].breed;
              this.edad = this.pet_information[0].age;
              this.peso =this.pet_information[0].weight;
              this.url_img = this.pet_information[0].url;
              this.imagenPreview = this.pet_information[0].url;
            }
           }else{
            console.log('tenemos que agregar')
           }
      });

      console.log(this.operation);
      console.log(this.id);
  }
  
  
 

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.convertToBase64(file);
    }
  }


 
 

  convertToBase64(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      //
      this.imagenPreview = reader.result as string;
      this.selectedFileBase64 = reader.result as string;

      console.log('image-->'+this.selectedFileBase64)
      // You can now send this.selectedFileBase64 to your backend or use it directly
    };
    reader.onerror = (error) => {
      console.error('Error reading file:', error);
    };
    reader.readAsDataURL(file); // Reads the file as a data URL (Base64)
  }

  
  registrarMascota() {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';


    if (!token) {
    console.error('No hay token de acceso disponible');
      this.snackbar.open('No autorizado. Por favor inicia sesión.', 'Cerrar', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
    return;
    }


    const body_pet = {
      "identifier":{
          "tenants":"adff7f6a-e97d-11eb-9a03-0242ac130003",   
          "app":"PortalAsistencia", 
      },
      "petition": {
        idPet : this.id,
        petName: this.nombre,
        specie: this.especie,
        gender: this.genero,
        breed: this.raza,
        age: this.edad,
        weight: this.peso,
        image : this.selectedFileBase64?.split(',')[1]
      }
    }

    const data_pet = JSON.parse(JSON.stringify(body_pet));
    
    
    let url_petition='';
    if(this.update){
      url_petition = `${this.baseUrl}/pet/${cognitoId}/update`;
      if(this.imagenPreview == null){
        delete data_pet.image;
        //body_pet.petition.image = this.pet_information[0].url;     
     }
    }else{
      url_petition = `${this.baseUrl}/pet/${cognitoId}/registred`;
      delete data_pet.petition.idPet; 
    }
    

    const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
    });

    console.log('url.------>'+url_petition);
    console.log('headers.------>'+headers);    
    console.log(data_pet)

    
    if(!this.update){  
      this.http.post(url_petition,data_pet,{headers}).subscribe({
          next:(response_pet:any)=>{
            this.snackbar.open('The pet was added successfully', 'Cerrar', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });

            const profileDataStr = localStorage.getItem('profileData');

            if(profileDataStr){
              const profileData = JSON.parse(profileDataStr);
              profileData.pets.push(response_pet.data);

              console.log('actualizado'+profileDataStr);
              localStorage.setItem('profileData', JSON.stringify(profileData));
              this.router.navigate(['/profile-registros']);

            }
            
          },error:(pet_error)=>{
              this.snackbar.open('error in add pet', 'Cerrar', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'top',
            });

            console.log('error in client',pet_error);
            
          }
      });
    }else{

      this.http.put(url_petition,data_pet,{headers}).subscribe({
        next:(response_pet_update:any)=>{
          this.snackbar.open('The pet was update successfully', 'Cerrar', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });

          const profileDataStr = localStorage.getItem('profileData');
          if(profileDataStr){
            const profileData = JSON.parse(profileDataStr);
           
            profileData.pets = this.pet.filter(entity => entity.idPet != data_pet.petition.idPet);
            profileData.pets.push(response_pet_update.data)
            localStorage.setItem('profileData', JSON.stringify(profileData));

          }
          this.router.navigate(['/profile-registros']);
          
        },error:(pet_error)=>{
            this.snackbar.open('error in update pet', 'Cerrar', {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });

          console.log('error in client',pet_error);
          
        }
      });
    }
  }
}
